<template lang="pug">
    .v-container
        v-settings-table(
            :titles="titles"
            :translationPath="translationPath"
            :items="permissions"
            :saveAction="saveAction"
            :saveMutation="saveMutation"
            :existingTypes="existingTypes"
            @existingTypesChange="existingTypesChange($event)"
        )
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SettingsTable from '@/components/SettingsTable'

export default {
    components: {
        'v-settings-table': SettingsTable
    },
    data: () => ({
        titles: ['name', 'activation'],
        translationPath: {
            headers: '$vuetify.pages.Roles.permissionsSettings',
            data: '$vuetify.pages.Roles.permissionsList'
        },
        backUrl: { path: '/roles' },
        saveAction: 'roles/updatePermissions',
        saveMutation: 'roles/SET_PERMISSIONS',
        existingTypes: []
    }),
    computed: {
        ...mapGetters(['type']),
        ...mapState({
            permissions: state => state.roles.permissions
        })
    },
    created() {
        this.$store.dispatch('roles/getPermissions').then(() => {
            this.existingTypes = [...this.permissions.map(it => Object.assign({}, it))]
        })
    },
    methods: {
        existingTypesChange(data) {
            this.existingTypes = data.existingTypes
        }
    }
}
</script>

